import { PropertyValidationInformation } from '../../../util/PropertyValidationInformation';
import React from 'react';
import {
    Controlled_AutocompleteMultiSelectReferenceTextField,
} from './Controlled_AutocompleteMultiSelectReferenceTextField';
import {
    useProcessArtifactActions,
} from '../../../../resource/resources/artifacts/process_artifact/processArtifactResource';

export const Controlled_ProcessArtifactTextField= ({ objectIds, projectVersionId, onChange, readOnly, noLabel, propertyValidationInformation }: {
    objectIds: string[] | undefined;
    projectVersionId: string | undefined | null;
    onChange?: (id: string[] | null) => void;
    readOnly: boolean;
    noLabel?: boolean;
    propertyValidationInformation?: PropertyValidationInformation;
}) => {

    const processArtifactActions = useProcessArtifactActions()
    const processArtifactsQuery = processArtifactActions.useGetAllResources(projectVersionId);

    return (
        <Controlled_AutocompleteMultiSelectReferenceTextField
            idValues={objectIds}
            readOnly={readOnly}
            onChange={onChange}
            // propertyValidation={propertyValidation}
            // propertyDetails={noLabel ? undefined : propertyDetails}
            propertyValidation={null}
            propertyDetails={undefined}
            query={processArtifactsQuery}
            getOptionLabel={(option) => option.name}
            hideLabel={noLabel}
        />
    );
};